
import { defineComponent } from "vue";

let colSizes = [3, 2, 2, 1, 2, 1];

export interface IRow {
  socials: string[];
  followersCount: number;
  industry: string[];
  locale: string;
  date: number;
  amount: number;
}

export default defineComponent({
  name: "SancusTableRow",
  props: ["srcData"],
  methods: {
    getClasses(index: number) {
      var classes = "";
      classes += "col-span-" + colSizes[index];
      return classes;
    },
    renderItem(key: string) {
      if (key == "socials" || key == "industry") {
        return this.srcData[key].join(", ");
      } else if (key == "date") {
        return new Date(this.srcData[key]).toLocaleDateString();
      }
      return this.srcData[key];
    },
  },
});
